module.exports = "<app-spinner ng-if=\"$ctrl.isProcessing\" ></app-spinner>\n<app-error error=\"$ctrl.error\">{{$ctrl.error}}</app-error>\n\n<catalog-navbar></catalog-navbar>\n<div class=\"tabClassic card\" role=\"tabpanel\" >\n  <product-categories categories=\"$ctrl.categories\"></product-categories>\n  <div role=\"tabpanel\">\n    <product-filters filter=\"$ctrl.filter\" ng-if=\"$ctrl.catalogType !== 'maps'\"></product-filters>\n    <products category=\"$ctrl.category\" filter=\"$ctrl.filter\" ng-if=\"$ctrl.category\"></products>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/catalog/catalog-content/catalog-content.html
// module id = 1110
// module chunks = 0